$width: 25px;
$height: 25px;
$radius: $width * 0.5;
:host {
  .av-pointer {
    display: block;
    background-color: var(--av-color-accent); // darken
    width: $width;
    height: $height;
    margin-top: -($height * 0.5) + 10;
    margin-left: -($width * 0.5)+ 10;
    border-radius: 0px $radius $radius $radius;
    position: fixed;
    box-shadow: 0 4px 8px -1px fade-out($color: black, $amount: 0.7);
    z-index: 100000;
    pointer-events: none;
    top: 0;
    left: 0;

    .av-pointer-sender {
      position: absolute;
      background-color: var(--av-color-accent);
      top: 5px;
      left: 30px;
      padding: 2px 5px;
      font-size: 0.8em;
      font-weight: bold;
      color: var(--av-color-accent-contrast);
      border-radius: 10px;
      box-shadow: 0 4px 8px -1px fade-out($color: black, $amount: 0.7);
      pointer-events: none;
    }
  }
}
